import React from 'react';
import { Paper, Typography, Fade, Box } from '@mui/material';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import { useGame } from '../contexts/GameContext';

export default function DrinkingBuddies() {
  const { state } = useGame();
  const { drinkingBuddies } = state;

  if (!drinkingBuddies) return null;

  return (
    <Fade in timeout={500}>
      <Paper 
        sx={{ 
          p: 2,
          mt: 2,
          bgcolor: 'background.default',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '1rem',
        }}
      >
        <Typography 
          variant="h6" 
          sx={{ 
            mb: 2,
            fontWeight: 'bold',
            background: 'linear-gradient(45deg, #FF8E53 30%, #FE6B8B 90%)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          <LocalBarIcon fontSize="small" />
          Drinking Buddies
        </Typography>

        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: 1,
            pl: 1,
            borderLeft: '2px solid',
            borderColor: '#FF8E53'
          }}
        >
          <Typography variant="body2">
            {drinkingBuddies[0]} 🍻 {drinkingBuddies[1]}
          </Typography>
        </Box>
      </Paper>
    </Fade>
  );
} 